module.exports = __webpack_public_path__ + "img/大楼.c84855da.png";